import { render, staticRenderFns } from "./controlePagamentos.vue?vue&type=template&id=061a9012&scoped=true&"
import script from "./controlePagamentos.vue?vue&type=script&lang=js&"
export * from "./controlePagamentos.vue?vue&type=script&lang=js&"
import style0 from "./controlePagamentos.vue?vue&type=style&index=0&id=061a9012&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061a9012",
  null
  
)

export default component.exports